import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRushCalm = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 3C6 1.89543 6.89543 1 8 1C9.10457 1 10 1.89543 10 3C10 4.10457 9.10457 5 8 5C6.89543 5 6 4.10457 6 3ZM8 4C7.44772 4 7 3.55228 7 3C7 2.44772 7.44772 2 8 2C8.55228 2 9 2.44772 9 3C9 3.55228 8.55228 4 8 4Z'
    />
    <path d='M6.5 15C6.22386 15 6 14.7761 6 14.5V11H7V14.5C7 14.7761 6.77614 15 6.5 15Z' />
    <path d='M9.5 15C9.22386 15 9 14.7761 9 14.5V11H10V14.5C10 14.7761 9.77614 15 9.5 15Z' />
    <path d='M7.5 7C6.67157 7 6 7.67157 6 8.5V10.5C6 10.7761 5.77614 11 5.5 11C5.22386 11 5 10.7761 5 10.5V8.5C5 7.11929 6.11929 6 7.5 6H8.5C9.88071 6 11 7.11929 11 8.5V10.5C11 10.7761 10.7761 11 10.5 11C10.2239 11 10 10.7761 10 10.5V8.5C10 7.67157 9.32843 7 8.5 7H7.5Z' />
  </svg>
);
export default SvgRushCalm;
